import * as mutationTypes from './mutation-types'

const Contexts = {
  state() {
    return {
      contexts: {},
    }
  },

  getters: {
    contextByLedgerTypeAndId: (state) => (ledger_id, type, id) => {
      return state.contexts[ledger_id][type][id]
    },
  },

  mutations: {
    [mutationTypes.SET_CONTEXTS](state, contexts) {
      state.contexts = contexts
    },
  },
}

export default Contexts
